import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';

import { ApprovalStatus } from 'rev-shared/media/MediaConstants';
import { ApprovalStatusInfo } from './ApprovalStatusInfo';

import { DialogService } from 'rev-shared/ui/dialog/Dialog.Service';
import { SecurityContextService } from 'rev-shared/security/SecurityContext.Service';
import { UserContextService } from 'rev-shared/security/UserContext.Service';
import { VideoPlaybackService } from '../VideoPlayback.Service';

import styles from './approval-process-container.module.less';

@Component({
	selector: 'approval-process-container',
	templateUrl: './ApprovalProcessContainer.Component.html'
})
export class ApprovalProcessContainerComponent implements OnInit, OnChanges {
	@Input() private video: any;
	@Output() private deleteVideoEvent: EventEmitter<void> = new EventEmitter();

	private readonly styles = styles;

	private approvalTemplates: any[];
	private isSubmitted: boolean;

	public approvalLoaded: boolean = false;
	public statusInfo: ApprovalStatusInfo;

	constructor(
		private SecurityContext: SecurityContextService,
		private UserContext: UserContextService,
		private VideoPlaybackSvc: VideoPlaybackService,
		private Dialog: DialogService
	) { }

	public ngOnInit(): void {
		this.VideoPlaybackSvc.approvalProcessTemplates$(this.video.approval.userId)
			.subscribe(templates => {
				this.approvalTemplates = templates;
				this.approvalLoaded = true;
			});
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.video && this.video) {
			this.statusInfo = new ApprovalStatusInfo(this.video.approval.status, this.video.approval.contentAnalysis);
		}
	}

	public get isVideoOwner(): boolean {
		return [this.video.replacedBy, this.video.owner.userId, this.video.approval.userId]
			.includes(this.UserContext.getUser().id);
	}

	public get isMediaAdmin(): boolean {
		return !!this.SecurityContext.checkAuthorization('admin.media');
	}

	public get isVideoApprover(): boolean {
		return this.video.approval && this.video.approval.isTemplateApprover;
	}

	public get isInitialStatusApproved(): boolean {
		return this.video.approval.initialStatus === ApprovalStatus.APPROVED;
	}

	public submitApproval({ templateId }: { templateId: string; }): void {
		this.isSubmitted = true;
		this.VideoPlaybackSvc.submitForApproval(this.video.id, templateId, this.video.approval.userId)
			.finally(() => this.isSubmitted = false);
	}

	public rejectVideo(): void {
		this.Dialog.getDialog('ApprovalDialog').open({
			initialState: {
				video: this.video,
				isApproved: false
			}
		});
	}

	public approveVideo(): void {
		this.Dialog.getDialog('ApprovalDialog').open({
			initialState: {
				video: this.video,
				isApproved: true
			}
		});
	}

	public deleteVideo(): void {
		this.deleteVideoEvent.emit();
	}

}
